import { ProductComputedPrice } from '~/Api/User/ProductGroup/LtMaxPrice/ProductComputedPrice';
import { ProductPrice } from '~/Product';

export class ReferencePrice {
	public readonly calculatedPrice: ProductComputedPrice;

	public readonly sourcePrice: ProductPrice;

	public constructor(sourcePrice: ProductPrice, calculatedPrice: ProductComputedPrice) {
		this.sourcePrice = sourcePrice;
		this.calculatedPrice = calculatedPrice;
	}
}
